type Listener = (args?: { [key: string]: any }) => void;

export class EventProxy {
  private onListeners: { [key: string]: Listener[] };
  private oneListeners: { [key: string]: Listener[] };

  constructor(on = {}, one = {}) {
    this.onListeners = on;
    this.oneListeners = one;
  }

  on = (key: string, listener: Listener) => {
    if (this.onListeners[key] === undefined) {
      this.onListeners[key] = [];
    }

    this.onListeners[key].push(listener);

    return () => {
      const index = this.onListeners[key].indexOf(listener);
      if (index !== -1) {
        this.onListeners[key].splice(index, 1);
      }
    };
  };

  one = (key: string, listener: Listener) => {
    if (this.oneListeners[key] === undefined) {
      this.oneListeners[key] = [];
    }

    this.oneListeners[key].push(listener);

    return () => {
      const index = this.oneListeners[key].findIndex(listener);
      if (index !== -1) {
        this.oneListeners[key].splice(index, 1);
      }
    };
  };

  off = (key: string) => {
    this.onListeners[key] = [];
    this.oneListeners[key] = [];
  };

  emit = (key: string, args?: { [key: string]: any }) => {

    if (
      this.onListeners[key] !== undefined &&
      this.onListeners[key].length !== 0
    ) {
      for (const listener of this.onListeners[key]) {
        listener.call(undefined, args);
      }
    }

    if (
      this.oneListeners[key] !== undefined &&
      this.oneListeners[key].length !== 0
    ) {
      for (const listener of this.oneListeners[key]) {
        listener.call(undefined, args);
      }

      this.oneListeners[key] = [];
    }
  };
}

export const instance = new EventProxy();
